// extracted by mini-css-extract-plugin
export var gameBoard = "GameBoard-module--gameBoard--OEfeC";
export var counter = "GameBoard-module--counter--R+9vo";
export var cards = "GameBoard-module--cards--EgZqn";
export var hide = "GameBoard-module--hide--FM1rJ";
export var times = "GameBoard-module--times--FeLL4";
export var times_title = "GameBoard-module--times_title--EsiBR";